import {EChannelType} from 'src/constants';

import {EVerificationError, EVerificationStatus} from './Verification/definitions';
import {EMessagingLimit, EQualityScore, EQualityStatus, EStatus, EWabaStatus} from './definitions';

export default {
  channel: 'channel',
  searchPlaceholder: 'Quick search by channel name or ID',
  channels: 'Channels',
  filters: {
    channelLabel: 'Channel',
    channelStatuses: 'Channel status',
    channels: 'channels',
  },
  verification: {
    title: 'Verification requests',
    whatsappTitle: 'Business verification requests',
    itemTitle: 'Verification request {{id}}',
    add: 'Create request',
    statusLabel: 'Request status',
    status: {
      [EVerificationStatus.DRAFT]: 'Draft',
      [EVerificationStatus.MANAGER_REVIEW]: 'Under review by edna',
      [EVerificationStatus.NEEDS_CORRECTION]: 'Requires revision',
      [EVerificationStatus.PENDING]: 'Under verification by Meta',
      [EVerificationStatus.APPROVED]: 'Verification approved',
      [EVerificationStatus.REJECTED]: 'Verification rejected',
      [EVerificationStatus.REJECTED_PERMANENTLY]: 'Verification not available in the dashboard',
    },
    error: {
      [EVerificationError.UNDEFINED_ERROR]:
        'An error occurred while submitting the request. Please try again. If the issue persists, contact support.',
      [EVerificationError.FAILED_TO_SUBMIT]:
        'Failed to submit the request. Please try again. If the issue persists, contact support.',
      [EVerificationError.WRONG_OBJECT_TYPE_WABA]:
        'Invalid company ID. Check your details and submit the request again. If the issue persists, contact support.',
      [EVerificationError.BUSINESS_INFORMATION_IS_STILL_REVIEWING]:
        'The business is still under Facebook review. Please try again later. If the issue persists, contact support.',
    },

    businessPortfolioId: 'Business Portfolio ID',
    businessPortfolioIdHintOne: 'Go to Business Manager <0>→</0>Business Info.',
    businessPortfolioIdHintTwo:
      'Your Business Portfolio ID is displayed next to your company name.',
    websiteUrl: 'Link to your official website',
    websiteUrlHint:
      'Provide a link to a page that displays your company’s legal name, address, and phone number. Make sure that the company’s legal name, address and phone number fully match the details in the business portfolio info and are included in the documents uploaded to verify the company. The same website must be listed in your business portfolio info.',
    documents: 'Upload official documents',
    documentsHint:
      'Upload up to 3 documents that confirm your company’s legal name, address, and phone number. The maximum size for each file is 5 MB. Supported formats: PDF, JPEG, JPG, PNG.',
    documentsHintListTitle: 'Accepted documents:',
    documentsHintList: 'Accepted documents:',
    documentTypes: [
      'Certificate or Articles of Incorporation',
      'Business Registration or License Document',
      'Government-issued Business Tax Document',
      'Business Bank Statement',
      'Utility Bill (accepted only for verifying business address and phone number)',
    ],
    documentUpload: 'Upload documents',
    documentError: 'The maximum allowed file size is 5 MB. The document is too large.',
    success: {
      title: 'Request sent to the manager',
      description:
        'edna will review your request and submit it to Meta for verification. If any document updates are required, your manager will return the request for revision and let you know what needs to be corrected.',
    },
    successVerification: {
      title: 'Your company has successfully passed Meta business verification!',
      description: 'Congratulations! You now have access to advanced business features:',
      point1:
        'Higher messaging limits for all WhatsApp channels – <0>check your current limits</0>',
      point2: 'Displaying your company name instead of a phone number',
      point3:
        'Ability to request the official verification badge (green checkmark) – <0>follow the instructions</0>',
    },
    existsError: 'A request with this Business Portfolio ID already exists',
    documentsError: 'Official documents are required',
    requestRejected: 'Your verification request has been rejected',
    requestRejectedPermanently: 'You can complete the verification directly in Meta.',
    requestRejectedAttempts:
      'Your request was rejected for the following reason: {{reason}}.<br/>You can make the required changes and submit the request again. Attempts left: {{attempt}} of {{maxAttempts}}.',
    list: {
      editDate: 'Edit date',
      businessPortfolioId: 'Business Portfolio ID',
      status: 'Status',
      empty: 'You have no requests yet',
    },
  },
  status: {
    [EStatus.DRAFT]: 'Draft',
    [EStatus.ACTIVE]: 'Correct',
    [EStatus.PROBLEM]: 'Problem',
    [EStatus.NEEDS_ATTENTION]: 'Requires attention',
    [EStatus.DISABLED]: 'Disabled',
    [EStatus.REGISTRATION]: 'Under consideration',
    [EStatus.CANCELED]: 'Canceled',
  },
  wabaStatus: {
    [EWabaStatus.ACCOUNT_RESTRICTION]: 'Limited (WABA)',
  },
  qualityStatus: {
    [EQualityStatus.FLAGGED]: 'Warning',
    [EQualityStatus.RESTRICTED]: 'Limited',
    [EQualityStatus.CONNECTED]: 'Correct',
  },
  th: {
    channelId: 'Subject ID',
    type: 'Type',
    name: 'Name',
    subject: 'Sender',
    status: 'Channel status',
  },
  techPartnerChannel: {
    [EChannelType.WHATSAPP]: 'Customer WhatsApp channel',
    [EChannelType.MAX]: 'Customer MAX',
    [EChannelType.TELEGRAM]: 'Customer Telegram',
    whatsAppBusinessApp: 'Customer WhatsApp Business App channel',
  },
  whatsAppBusinessApp: 'WhatsApp Business App',
  whatsAppBA: 'WhatsApp BA',
  changeUrl: 'Update link',
  copyUrl: 'Copy link',
  deleteConfirm: 'Are you sure you want to remove the channel "{{name}}"? This cannot be undone.',
  successRegister: {
    head: 'The channel form has been registered!',
    text: 'The registration form has been completed and sent.<br /><br />Now you can see the channel registration statuses in the channel list and on the channel page.',
  },
  empty: {
    title: 'This is empty for now',
    subtitle: 'No channels yet. Create your first channel to start sending messages to recipients',
  },
  editForm: {
    tariffLabel: 'Pricing for the channel',
    tariffPlaceholder: 'Select pricing',
  },
  messages: {
    important: 'Important!',
    needAcceptTariffs:
      'To register a channel, you need to accept the pricing specified on the Pricing tab in <0>Company Profile</0>.',
    noTariffs:
      'There are no pricing options available for this channel. If you want to register the channel, contact <0>your manager</0>.',
  },
  qualityScoreLabel: 'Channel quality',
  limitLabel: 'Daily limit',
  messagesLimit: 'Daily limit of outgoing messages',
  qualityUpdatedAt: 'Date of limit update',
  activeChannel: 'Correct channel operation',
  restrictedChannel: 'Channel operation is temporarily restricted',
  restrictedChannelDescription:
    'This channel has reached its daily limit of outgoing messages. The channel is only available for incoming requests.',
  flaggedChannel: 'Violations recorded in the channel',
  flaggedChannelDescription:
    'This channel has received many complaints. Daily limits can be reduced.',
  aboutLimits: 'More about limits',
  qualityWarning: 'Daily limits can be reduced',
  flaggedWarning: 'Violations recorded',
  qualityScore: {
    [EQualityScore.GREEN]: 'High',
    [EQualityScore.YELLOW]: 'Medium',
    [EQualityScore.RED]: 'Low',
    [EQualityScore.NA]: 'Unknown',
  },
  limit: {
    [EMessagingLimit.TIER_50]: '50',
    [EMessagingLimit.TIER_250]: '250',
    [EMessagingLimit.TIER_1K]: '1000',
    [EMessagingLimit.TIER_2K]: '2000',
    [EMessagingLimit.TIER_10K]: '10 000',
    [EMessagingLimit.TIER_100K]: '100 000',
    [EMessagingLimit.TIER_UNLIMITED]: 'Unlimited',
    [EMessagingLimit.TIER_NOT_SET]: 'Unknown',
  },
};
